import axios from 'axios'
import { Message, Loading} from 'element-ui'
import store from "../store/store";
import router from "../route/router";
let loading = null
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '' : '/firepointApi/', //基础路径
  timeout: 15000
})
service.interceptors.request.use(
  config => {
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      config.headers.accessToken = `${JSON.parse(userInfo).accessToken}`
      if (JSON.parse(userInfo).username) {
        config.headers.username = JSON.parse(userInfo).username
      }
    }
    if (config.method === 'post' || config.loading) {
      loading = Loading.service({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    }
    return config
  },
)
service.interceptors.response.use(
  response => {
    if (loading) loading.close()
    if (response.data.status === 0) {
      return Promise.resolve(response.data)
    }
    if (response.data.code === 200) {
      return Promise.resolve(response.data)
    } else {
      Message.error(response.data.msg)
      return Promise.reject(response.data)
    }
  },
  error => {
    if (loading) loading.close()
    if (axios.isCancel(error)) {
      return Promise.reject('取消了请求') // 取消了请求
    } else if (error.response && error.response.status === 401) {
      Message.error('未登录，请立即登录')
      return store.dispatch('systemLoginOut').then(() =>{
        router.push({ name: 'login' })
      })
    } else if (error.response && error.response.status === 404) {
      Message.error('请求失败，请稍后再试')
      return Promise.reject(error)
    }
    Message.error('系统正在更新，请稍后再试')
    return Promise.reject(error)
  }
)

export default service

